// extracted by mini-css-extract-plugin
export default {"zoomModal":"M2-z"};